import { TypedDocumentNode, gql } from '@apollo/client';

import { Token } from 'components/token/Token';
import TokenFavoriteButton from 'components/token/TokenFavoriteButton';

import {
  TokensByIdsQuery,
  TokensByIdsQueryVariables,
} from './__generated__/fragments.graphql';

export const TOKENS_BY_IDS_QUERY = gql`
  query TokensByIdsQuery(
    $slugs: [String!]!
    $onlyPrimary: Boolean!
    $googlePlayStoreCountryCode: String
    $isAndroidApp: Boolean = false
    $isIosApp: Boolean = false
  ) {
    anyCards(slugs: $slugs) {
      slug
      sport
      ...TokenFavoriteButton_anyCard
      ...Token_anyCard
    }
  }
  ${Token.fragments.anyCard}
  ${TokenFavoriteButton.fragments.anyCard}
` as TypedDocumentNode<TokensByIdsQuery, TokensByIdsQueryVariables>;
